export default {
  register: "회원가입",
  welcome: "환영합니다",
  textWelcome: "환영합니다",
  textGoodMorning: "좋은 아침이에요",
  textGoodAfternoon: "안녕하세요",
  textGoodEvening: "안녕하세요",
  textGoodNight: "안녕히 주무세요",
  loginFail: "로그인 실패",
  phone: "전화번호",
  email: "이메일",
  agreeTermAndCondition: "이용 약관 동의",
  pleaseAgreeTermAndCondition: "개인정보 처리방침에 동의해 주세요",
  back: "뒤로",
  termAndCondition: "이용 약관",
  termAndCondition2: "이용 약관",
  cancel: "취소",
  confirm: "확인",
  confirmDefault: "확인",
  confirmRegistration: "등록 확정",
  addItem: "항목 추가",
  required: "이 필드를 입력해 주세요",
  zipcode: "우편번호",
  sub_district: "동/면/리",
  district: "구/군",
  province: "시/도",
  save: "저장",
  saveDraft: "임시 저장",
  close: "닫기",
  name: "이름",
  surname: "성",
  birthDay: "생년월일",
  gender: "성별",
  educationLevel: "학력",
  jobLevel: "직급",
  jobPosition: "직책",
  department: "부서",
  company: "회사",
  address: "주소",
  enterRegister: "회원가입",
  management: "경영진",
  manager: "매니저/팀장",
  supervisor: "수퍼바이저/관리자",
  officer: "사원/직원",
  worker: "작업자/현장직",
  doctorate: "박사",
  masterDegree: "석사",
  bachelorDegree: "학사",
  highVocational: "전문학사",
  technicalVocational: "기술 자격",
  vocational: "직업 자격",
  highSchool: "고등학교",
  secondarySchool: "중학교",
  primarySchool: "초등학교",
  lowerPrimary: "초등 미만",
  male: "남성",
  female: "여성",
  other: "기타",
  profile: "프로필",
  id: "아이디",
  nameSurname: "성함",
  sendRefCodeOtp: "참조 코드",
  requestOtpAgain: "OTP 재전송",
  edit: "수정",
  add: "추가",
  addressSendReward: "배송지 주소",
  addressDetail: "상세 주소",
  selectDefautAddress: "기본 주소로 설정",
  addressEdit: "주소 수정",
  addressAdd: "주소 추가",
  defaultValue: "기본값",
  hello: "안녕하세요, {name}님",
  coinTotal: "보유 포인트",
  homePage: "홈",
  activityPage: "활동",
  redemptPage: "경품 교환",
  invitePage: "친구 초대",
  connectPlatformPage: "플랫폼 연결",
  connectPlatformPageHint: "특별 혜택을 위해 이커머스를 연결하세요",
  birthDayPage: "생일 선물",
  addressPage: "배송지 관리",
  favoritePage: "관심 목록",
  cancelShipment: "배송 취소",
  couponPage: "내 쿠폰",
  myLuckyDrawPage: "내 응모 내역",
  myMemberPage: "내 멤버십",
  registerMemberPage: "멤버십 등록",
  statusDeliveryPage: "경품 배송 상태",
  transferPage: "포인트 이체",
  logout: "로그아웃",
  textCategory: "카테고리",
  categoryAll: "전체",
  categoryRecommend: "추천",
  categoryFood: "음식",
  categoryElectrical: "전자제품",
  categoryAppliance: "가전제품",
  categoryOther: "기타",
  totalValue: "남은 수량",
  detail: "상세 정보",
  seeMoreDetail: "상세 보기",
  youWant: "정말로 ",
  delete: "삭제",
  favoriteText: "관심 목록에 추가하시겠습니까?",
  waitingLoad: "잠시만 기다려 주세요",
  expireTime: "만료됨",
  coin: "포인트",
  surveyRegister: "등록 양식",
  later: "나중에",
  redeem: "교환하기",
  redeemPoint: "사용 포인트",
  confirmRedeem: "포인트를 사용하여 교환하시겠습니까?",
  confirmAdd: "추가하시겠습니까?",
  inYourFav: "관심 목록에",
  confirmDelete: "삭제하시겠습니까?",
  fromYourFav: "관심 목록에서",
  balance: "잔액",
  inviteFrindDetail: "친구를 초대해 보세요. 친구가 성공적으로 가입하면,",
  received: "수령함",
  inviteFriend: "친구 초대",
  inviteFriendPhoneText: "초대할 친구의 전화번호를 입력하세요",
  inviteFriendLineText: "LINE으로 친구 초대",
  fillPhone: "친구 전화번호 입력",
  historyRedeem: "교환 내역",
  historyCode: "코드 내역",
  resendCode: "코드 재전송",
  coinAll: "전체",
  coinReceived: "획득 포인트",
  coinUsed: "사용 포인트",
  activityAll: "모든 활동",
  expireDate: "만료일",
  note: "메모",
  enterNote: "메모 입력...",
  checkIn: "체크인",
  activityExpireDate: "활동 만료일",
  collectCoin: "포인트 적립",
  valueItem: "수량",
  missionReward: "보상",
  activityJoin: "활동 참여",
  activityQr: "QR 코드 스캔",
  activitySurvey: "설문 참여",
  activityUpload: "활동 결과 업로드",
  activityScanQr: "QR 스캔",
  scanCode: "코드 스캔",
  sendSurvey: "설문 제출",
  uploadFile: "파일 업로드",
  sizeFile: "파일 크기는 10MB를 초과할 수 없습니다",
  activityStatusJoin: "참여 중인 활동",
  activityStatusWait: "대기 중인 활동",
  activityStatusSuccess: "성공한 활동",
  activityStatusReject: "거절된 활동",
  activityStatusAll: "모든 활동",
  registerToReceive: "등록하고 받기",
  confirmUseCoupon: "쿠폰 사용 확인",
  noteUseCoupon:
    "권리 소멸을 방지하기 위해 매장에서 사용하실 때 쿠폰을 사용 버튼을 누르시는 것을 권장합니다.",
  noteAlertUseCoupon: "클레임 클릭 즉시 코드가 사용된 것으로 간주됩니다.",
  codeDiscount: "할인 코드",
  errorQr: "QR 코드 렌더링에 실패했습니다.",
  cancelRedemption: "거래를 취소하시겠습니까?",
  cancelRedemptionNote: "거래를 취소하면 포인트를 받을 수 없습니다.",
  statusDelivery: "경품 배송 상태",
  statusSendIn7Day: "7일 이내 배송",
  shippingInProcess: "처리 중",
  statusDeliverySuccess: "배송 완료",
  statusDeliveryCancel: "배송 취소",
  trackingNumber: "송장 번호",
  receiveReward: "경품 수령",
  copyText: "복사됨",
  confirmReceiveReward: "경품 수령 확인",
  activitySuggest: "추천 활동",
  pageNotFound: "페이지를 찾을 수 없습니다",
  goBackPage: "이전 페이지로",
  goToLogin: "로그인 페이지로 이동",
  changeLanguage: "언어",
  all: "전체",
  join: "참여",
  joined: "joined",
  success: "성공",
  failed: "실패",
  waiting: "대기 중",
  pending: "대기",
  sent: "발송됨",
  delivered: "배송됨",
  textRequireOTPAgain: "새 OTP 코드 재요청 가능 시간: ",
  welcomeActivity: "활동 참여를 환영합니다",
  errQr: "유효하지 않은 QR 코드입니다. 다시 시도해 주세요.",
  requireExam: "설문지를 완료해 주세요.",
  uploadSuccess: "결과가 전송되었습니다.",
  uploadWaiting: "7일 이내에 검토가 완료될 예정입니다.",
  errDupActivity: "이미 완료한 작업입니다. 다른 활동을 선택해 주세요.",
  errExpireActivity: "죄송합니다, 활동 기간이 종료되었습니다.",
  errActivity: "죄송합니다, 이 활동에 참여할 자격이 없습니다.",
  errFileUpload: "파일 크기는 10MB를 초과할 수 없습니다.",
  errMyLuckyDrawNotEnough: "죄송합니다, 응모 횟수가 부족합니다.",
  expireDateUse: "만료일",
  registerPage: "회원가입 페이지",
  shareActivity: "활동 공유",
  goToMission: "활동 보기",
  menuActivity: "활동",
  menuRedeem: "포인트 교환",
  menuCoupon: "내 쿠폰",
  privacyPolicy: "개인정보 처리방침",
  favoriteCategory: "관심 목록",
  deviceCategory: "전자 기기",
  accessoryCategory: "전자 악세서리",
  healthCategory: "건강 & 뷰티",
  foodCategory: "음식 & 음료",
  babyCategory: "유아 & 장난감",
  petCategory: "반려동물",
  homeCategory: "홈 & 라이프스타일",
  menCategory: "남성 패션",
  womenCategory: "여성 패션",
  sportCategory: "스포츠",
  travelCategory: "여행",
  reward: "보상",
  missionComing: "예정된 미션",
  startDate: "시작일",
  endDate: "종료일",
  home: "홈",
  activity: "활동",
  tracking: "배송 조회",
  account: "계정",
  historyCoupon: "쿠폰 사용 내역",
  rewardSoHot: "인기 경품",
  hotMission: "인기 활동",
  recommendMission: "추천 활동",
  doneDetailMission: "참여 상세 내용",
  detailMission: "활동 상세 정보",
  newActivityUpload: "재전송",
  errNotTimeForActivity: "아직 활동 시작 전입니다.",
  news: "소식",
  birthDayGift: "생일 선물",
  friendRecommend: "추천 친구",
  friendRequest: "친구 요청",
  friendList: "친구 목록",
  rewardLimitReached: "보상 한도 도달",
  limitReached: "한도 도달",
  limitReachedPerDay: "일일 한도 도달",
  textComingSoon: "곧 시작됩니다",
  textTimeCannotJoin: "활동 기간이 아닙니다",
  couponExpired: "쿠폰 만료",
  myLuckyDrawExpire: "만료됨",
  conditionCoin: "약관 적용",
  rewardPrize: "경품",
  agree: "동의",
  disagree: "비동의",
  activityHeartToHeart: "메시지 보내기",
  rewardComingSoon: "출시 예정",
  addMember: "멤버 추가",
  conditionEntryPass: "입장 조건",
  letsJoin: "지금 참여하기",
  isUsed: "사용됨",
  editProfile: "프로필 수정",
  textProfile: "프로필",
  searchMissionOrReward: "활동 또는 경품 검색",
  searchHistory: "검색 기록",
  removeSearchHistory: "검색 기록 삭제",
  messageActivityUpcoming: "기대해 주세요! 새로운 활동이 곧 시작됩니다 🎉",
  messageActivityErrorReJoin: "작업 실패.\n활동 페이지에서 직접 참여해 주세요.",
  errActivityAlreadyJoined: "죄송합니다, 이미 참여한 활동입니다.",
  errActivityDataNotFound: "죄송합니다, 활동 정보를 찾을 수 없습니다.",
  redeemSuccessWithClaimInstruction:
    "교환 성공! '내 경품'에서 선물을 확인하세요.",
  redeemSuccess: "교환 성공",
  errRewardOutOfStock: "죄송합니다, 경품이 품절되었습니다.",
  errRedeemFail: "죄송합니다, 교환에 실패했습니다. 다시 시도해 주세요.",
  textSorry: "죄송합니다,",
  errDataNotFound: "죄송합니다, 데이터를 찾을 수 없습니다.",
  errSubmissionFailed: "죄송합니다, 제출에 실패했습니다. 다시 시도해 주세요.",
  errRegistrationFailedContactAdmin:
    "등록에 실패했습니다. 관리자에게 문의하세요.",
  btnRedirectMyCoupon: "내 쿠폰함으로 이동",
  infoCouponReadyMyCoupons: "'내 쿠폰'에서 쿠폰을 사용하실 수 있습니다.",
  coinCost: "필요 포인트",
  next: "다음",
  skip: "건너뛰기",
  otpVerified: "OTP 인증됨",
  successOTPVerified: "OTP 인증에 성공했습니다",
  dataNotFound: "데이터를 찾을 수 없습니다",
  version: "버전",
  viewAll: "전체 보기",
  availableStock: "남은 수량",
  expiredAt: "만료 예정",
  expiredAt2: "만료일",
  rewardToReceive: "받을 보상",
  chooseRewardToReceive: "보상을 선택해 주세요",
  viewResultActivity: "활동 결과 보기",
  titleInvite:
    "{name}님이 독점 혜택을 받을 수 있는 로열티 프로그램에 귀하를 초대했습니다.",
  thankYouForParticipatingActivity: "참여해 주셔서 감사합니다!",
  doActivityBy: "수행자:",
  textNotSpecified: "미지정",
  textIncognito: "익명 모드",
  viewHistory: "기록 보기",
  history: "기록",
  locationName: "장소명",
  location: "위치",
  selectRedeemRewardLocation: "수령 장소 선택",
  selectAddressSendReward: "배송 주소 선택",
  instructionAddAddressSendReward: "배송지 주소를 추가해 주세요.",
  textSelect: "선택",
  instructionEnterRegisteredPhone:
    "계정이 이미 있는 경우, 등록된 전화번호를 입력하세요.",
  instructionEnterRegisteredEmail:
    "이미 등록하신 경우, 등록된 이메일을 입력해 주세요.",
  textFirstRegistration: "첫 등록",
  textClickHere: "여기를 클릭",
  statusRegistrationSuccess: "등록 성공",
  statusRegistrationFailed: "등록 실패",
  instructionUploadIDPassport: "신분증 또는 여권을 업로드해 주세요.",
  textUploadIDPassport: "신분증 / 여권 업로드",
  rewardStartDate: "교환 시작일",
  rewardExpiredDate: "경품 만료일",
  detailMyLuckyDraw: "응모 상세 정보",
  date: "날짜",
  errUserNotFound: "죄송합니다, 사용자를 찾을 수 없습니다.",
  textSelectUser: "사용자 선택",
  textSelectFile: "파일 선택",
  textImageType: "이미지",
  textVideoType: "동영상",
  instructionSelectOrAddAddress: "배송지 주소를 선택하거나 추가해 주세요.",
  instructionSelectRewardMission: "{amount}개의 보상을 선택해 주세요.",
  textTopRanking: "톱 랭킹",
  textRank: "순위",
  textTotalAmount: "총 금액",
  viewProfile: "프로필 보기",
  addFriend: "친구 추가",
  cancelFriend: "친구 삭제",
  removeFriendSuccess: "친구 목록에서 성공적으로 삭제되었습니다",
  instructionUploadImageVideo: "이미지/비디오 업로드 (최대 {size}MB)",
  textUnsupportedFileType: "지원되지 않는 파일 형식입니다.",
  textAdditionalDescription: "추가 설명",
  textDescription: "설명",
  textLocationOrBranchName: "위치 / 지점명",
  textCheckInTime: "체크인 시간",
  textCheckOutTime: "체크아웃 시간",
  textLastUpdate: "최근 업데이트",
  instructionLineReopenExternalBrowser:
    "로그인을 위해 외부 브라우저에서 다시 열어주세요.",
  errPhoneIsUsed: "죄송합니다, 이미 사용 중인 전화번호입니다.",
  textConditionEntryPassGamification: "참여 조건",
  textFree: "무료",
  textCongratsReceived: "축하합니다! 🎉 수령하셨습니다:",
  happyBirthMonth: "생일 축하의 달!",
  happyBirthMonthWish:
    "기쁨과 웃음, 그리고 당신에게 어울리는 선물들로 가득한 특별한 날이 되길 바랍니다! 🎁 올해는 당신에게 가장 좋은 일들만 가득하길 빌게요!",
  confirmDeleteMember: "{name} 멤버를 삭제하시겠습니까?",
  removeMemberSuccess: "멤버가 성공적으로 삭제되었습니다",
  removeMemberFail: "멤버 삭제에 실패했습니다",
  confirmEditProfile: "프로필 변경 사항을 저장하시겠습니까?",
  bonusCoin: "보너스 포인트",
  receiveCoin: "포인트를 획득하셨습니다",
  status: "상태",
  checkSendCodeHistory: "'내 쿠폰'에서 쿠폰을 사용하실 수 있습니다.",
  errTimeOut: "죄송합니다, 시간이 만료되었습니다.",
  inviteHeadline: "친구가 많을수록 더 즐겁습니다!",
  inviteFriendNow: "지금 친구를 앱으로 초대하세요!",
  copyInviteLink: "초대 링크 복사",
  copyInviteLinkSuccess: "초대 링크가 클립보드에 복사되었습니다",
  detailScanQrCode: "QR 코드를 중앙에 맞춰주세요.",
  pleaseFill: "내용을 입력해 주세요",
  comment: "댓글",
  claimSpecialGift: "특별 선물 받기",
  claimGift: "선물 받기",
  claimGiftSuccess: "선물을 성공적으로 받았습니다",
  list: "목록",
  summary: "요약",
  collected: "수집됨",
  collectedItemCount: "{count}개 수집됨",
  invalidPhoneNumber: "유효한 전화번호를 입력해 주세요",
  duplicateData: "중복된 데이터",
  saveSuccess: "저장되었습니다",
  uploadSuccessful: "업로드 성공",
  memberLevel: "현재 레벨",
  maxLevelReached: "축하합니다! 최고 레벨에 도달하셨습니다. 🎉",
  // earnMoreForNextLevel:
  //   "{nextLevelName} 레벨까지 {nextLevelEarn} 포인트 남았습니다",
  earnMoreForNextLevel: "{nextLevelName} 레벨까지 {nextLevelEarn} 남았습니다",
  code: "코드",
  codeNo: "코드 번호 {no}",
  qrCode: "QR 코드",
  barCode: "바코드",
  removeCache: "캐시 삭제",
  connect: "연결",
  luckyDrawCount: "기회",
  locationAccessDenied:
    "위치 정보를 가져올 수 없습니다. 위치 권한을 허용해 주세요.",
  viewing: "열람 중",
  cameraError: {
    notAllowed: "카메라 접근 권한을 허용해 주세요",
    notFound: "오류: 이 기기에서 카메라를 찾을 수 없습니다",
    notSupported: "오류: 보안 컨텍스트(HTTPS, localhost)가 필요합니다",
    notReadable: "오류: 카메라가 이미 사용 중입니까?",
    overconstrained: "오류: 설치된 카메라가 적합하지 않습니다",
    streamApiNotSupported:
      "오류: 이 브라우저에서는 Stream API를 지원하지 않습니다",
    insecureContext:
      "오류: 카메라 접근은 보안 컨텍스트에서만 허용됩니다. HTTP 대신 HTTPS나 localhost를 사용하세요.",
    unknown: "오류: 카메라 오류 ({error_name})",
  },
  error: {
    title: "오류가 발생했습니다",
    general: "문제가 발생했습니다. 다시 시도해 주세요.",
    unknown: "알 수 없는 오류가 발생했습니다",
    network: "네트워크 오류. 연결 상태를 확인해 주세요.",
    timeout: "요청 시간이 초과되었습니다.",
    notFound: "죄송합니다, 요청하신 정보를 찾을 수 없습니다.",
    unauthorized: "이 페이지에 접근할 권한이 없습니다.",
    sessionTimeout: "세션이 만료되었습니다. 다시 로그인해 주세요.",
    heicNotSupported: "HEIC/HEIF 파일은 지원되지 않습니다. JPG 또는 PNG를 사용해 주세요.",
    imageSupported: "JPG, JPEG, PNG 파일만 지원됩니다.",
    ocrProductNotFound: "스캔한 라벨과 일치하는 상품을 찾을 수 없습니다.",
  },
  yourCodeIs: "귀하의 코드는",
  validation: {
    required: "필수 항목입니다.",
    phoneInvalid: "전화번호가 유효하지 않습니다",
    emailInvalid: "올바른 이메일 형식이 아닙니다",
    enterOTP: "OTP를 입력해 주세요",
    otpInvalid: "OTP는 6자리 숫자여야 합니다",
    uploadLimit: "최대 {number}개까지 업로드 가능합니다",
    numberInvalid: "숫자여야 합니다",
    minCode: "코드를 하나 이상 입력해 주세요",
    maxFilesAllowed: "최대 {count}개의 파일까지 업로드할 수 있습니다",
    invalidFileFormat:
      "유효하지 않은 파일 형식입니다. 다른 파일을 업로드해 주세요.",
  },
  redeemAmount: "교환 수량: {quantity}",
  duration: "기간",
  webAccessDenied: "접근 거부: 이 웹사이트에 접근할 권한이 없습니다",
  webRedirecting: "올바른 웹사이트로 리다이렉트 중...",
  or: "또는",
  notEnough: "잔액이 부족합니다",
  notAvailable: "사용 불가.",
  amount: "금액",
  message: "메시지",
  loginLineLoading: "LINE 로그인 로딩 중...",
  signinWithLine: "LINE으로 로그인",
  signinWithGoogle: "Google로 로그인",
  sampleImage: "샘플 이미지",
  submitResult: "결과 제출",
  submit: "제출",
  unit: {
    km: "킬로미터",
    cc: "CC",
    unit: "개",
  },
  menuMain: "메인",
  menuMore: "더보기",
  menuChatRoom: "Inbox",
  menuInformationCenter: "Info Center",
  menuInformationCenterFull: "Information Center",
  menuCampaign: "Campaign",
  menuRequest: "Request",
  menuWarranty: "Warranty",
  joinedCampaigns: "Joined Campaigns",
  campaignTotalPoint: "Total Point",
  campaignTotalAmount: "Total Amount",
  allRequest: "All Requests",
  newRequest: "New Request",
  textFilter: "Filter",
  textSortBy: "Sort by",
  textUpdated: "updated",
  textAttachmentCount: "{count} Attachments",
  textAttachmentFile: "Attachment Files",
  textFilePreview: "File Preview",
  textReply: "Reply",
  textReplyForm: "Reply Form",
  textForm: "Form",
  textFillInForm: "Fill in form",
  textPost: "Post",
  textInputComment: "Comment",
  textViewMoreComment: "View more comments",
  textViewMoreReply: "View more replies",
  textRewardCount: "× {count} item(s)",
  filterAll: "All",
  filterFavorite: "Favorited",
  filterUnread: "Unread",
  filterNoType: "No Type",
  filterReportStatus: "Status : {report_status_name}",
  sortDate: "Sort by Date",
  sortTitle: "Sort by Title",
  sortExpiredDate: "Sort by Expired Date",
  sortProduct: "Sort by Product",
  sortRegisterDate: "Sort by Register Date",
  clear: "Clear",
  addFavorite: "Add to Favorites",
  removeFavorite: "Remove from Favorites",
  extraBonus: "Extra Bonus",
  deliveryPickup: "Pickup",
  deliveryThailandPost: "Thailand Post",
  pleaseFillDetail: "please input detail here ...",
  textTitle: "Title",
  textSubtitle: "Subtitle",
  textType: "Type",
  textProduct: "Product",
  hintUploadMultiFile:
    "Max {fileLimit} files, maximum total file size is {fileLimitMB} MB",
  errorUploadLimitFileSize:
    "Total file size exceeds the {fileLimitMB} MB limit.",
  specialReward: "Claim your special reward!",
  totalSummaryPoint: "Total Points",
  transferPoint: "Transfer Points",
  confirmTransferPoint:
    "Are you sure you want to transfer {point} points to {name}?",
  transferSuccess: "Points transferred successfully",
  transferDescription: "Transfer points to another member",
  selectRecipient: "Select recipient",
  selectMember: "Select member",
  enterTransferPoints: "Enter the number of points to transfer",
  transferPointAmount: "Points to transfer",
  transferPointType: "Type of Points to Transfer",
  transferPoints: "Transfer points",
  totalPoint: "Total point",
  myPointAll: "All",
  myPointExpire: "Expiring Soon",
  myPointExchange: "Redeem",
  total: "Total",
  toMember: "To",
  remaining: "Remaining",
  max: "Max",
  allWarranty: "All Warranties",
  warranty: "Warranty",
  warrantyRegistration: "Warranty Registration",
  newProductWarranty: "New Product",
  registerWarrantyDescription: "Register your purchase to activate your warranty.",
  registerNow: "Register Now",
  serviceRequest: "Service Request",
  warrantyStatus: {
    active: "ACTIVE",
    pending: "PENDING",
    rejected: "REJECTED",
    expired: "EXPIRED",
  },
  textUploadProductLabel: "Upload Product Label",
  textAutoFillByAI: "Auto-fill details with AI ✨",
  textBtnSelectPhoto: "Select Photo",
  textViewSamplePhoto: "View sample photo",
  textNumberMore: "+{number} more",
  textHide: "hide",
  microsite: {
    invalidPhoneNumber: "Please enter a valid phone number",
    otpVerified: "Confirm OTP",
    sendRefCodeOtp: "Ref OTP",
    textRequireOTPAgain: "Request a new OTP code again within : ",
    requestOtpAgain: "Request OTP Again",
    confirmDefault: "Confirm",
    enterOTP: "Please enter the OTP",
    otpInvalid: "OTP must be 6 digits",
    textTransactionDetail: "Transaction Detail",
    createdAt: "Date",
    summary_amount: "Summary Amount",
    point: "Point",
    status: "Status",
    status_detail: "Status Detail",
    item_name: "Item Name",
    item_image: "Item Image",
    Approved: "Approved",
    Waiting: "Waiting Approval",
    Rejected: "Rejected",
    Pending: "Pending",
    privacyPolicy: "Privacy<br />policy",
    termAndCondition: "Terms &<br />conditions",
    textNext: "Next",
    acceptConsent: "I accept",
    dataNotFound: "Data Not Found",
    maxFileSizeAllowed: "File Size is less than {size} MB.",
    maxFilesAllowed: "You can upload maximum {count} files",
    errSubmissionFailed: "Sorry, your submission failed.",
    errGeneral: "Something went wrong. Please try again.",
    successOTPVerified: "OTP Verified successfully",
    textBack: "Back",
    errActivityAlreadyJoined: "Sorry, you have already joined this activity.",
    textRefresh: "Refresh",
    errActivity: "Sorry, you cannot join this activity.",
    textRegistrationHistory: "REGISTRATION HISTORY",
    textTotalPoint: "Total point",
    textTotalAmount: "Total amount",
    textHistory: "HISTORY",
    textNo: "No",
    textCode: "Code",
    textSuccess: "Success",
    textNotFound: "Not Found",
    textUsed: "Used",
    errUserNotFound: "Sorry, user not found.",
    loginSuccess: "Login successful.",
    registerSuccess: "Register successful.",
    textResultsSummary: "Results Summary",
    textTopRankingCampaign: "Top {num} Ranking",
    textRank: "Rank",
    textPhone: "Phone Number",
    textTotal: "Total",
    textLuckyDrawClaimed:
      "You have already claimed your Lucky Draw rights for this campaign.",
    textContactAdminToChange:
      "To change your selection, please contact administrator.",
    textConnectWithLine: "Connect with LINE",
    textBackHome: "Home",
  },
};
